<template>
  <div>
    <tr-typography classes="vertical-offset1 block">
      Sugerimos o uso dos aplicativos: <a
        href="https://authy.com/download/"
        rel="noopener"
        target="_blank"
      >Authy</a> ou
      <a
        href="https://support.google.com/accounts/answer/1066447?src=soctw"
        rel="noopener"
        target="_blank"
      >Google Authenticator</a>.
    </tr-typography>
    <tr-switch
      classes="vertical-offset3"
      :is-checked="isChecked"
      :on-change="onSwitchChange"
      :label="`${isChecked ? 'Desativar' : 'Ativar'} a autenticação em 2 fatores`"
    />
    <tfa-activation-dialog
      ref="activationDialog"
      :on-hidden="refresh"
    />
    <tfa-deactivation-dialog
      ref="deactivationDialog"
      :on-hidden="refresh"
    />
  </div>
</template>

<script>
import TfaActivationDialog from './TfaActivationDialog';
import TfaDeactivationDialog from './TfaDeactivationDialog';
import loggedUserResource from '@/commons/resources/loggedUser';

export default {
  components: {
    TfaActivationDialog,
    TfaDeactivationDialog
  },
  data: () => ({
    isChecked: false
  }),
  created() {
    this.refresh();
  },
  methods: {
    refresh() {
      const loggedUser = loggedUserResource.get();
      this.isChecked = loggedUser.has_two_factor_enabled;
    },
    onSwitchChange(isChecked) {
      this.isChecked = isChecked;
      if (isChecked) {
        this.$refs.activationDialog.open();
      } else {
        this.$refs.deactivationDialog.open();
      }
    }
  }
};
</script>
